module.exports = __webpack_public_path__ + "static/img/brees-2007-slide-3.866ec29.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brees-2007-slide-3.jpg
// module id = pRPd
// module chunks = 1